import styled from "@emotion/styled";
import { motion } from "framer-motion";
import React from "react";
import { Shimmer } from "react-shimmer";
import CachedSignedVideo from "./CachedSignedVideo";

interface Props {
  src: string;
}

const size = 200;

function ChatMessageVideo(props: Props) {
  const fallback = <ChatMessageVideo.Fallback height={size} width={size} />;

  return (
    <ChatMessageVideo.Root>
      {props.src.startsWith("s3://") ? (
        fallback
      ) : (
        <Container layoutId={`card-container--index-${props.src.split("?")[0]}`} size={size}>
          <VideoWrapper>
            <CachedSignedVideo src={props.src} width={size} height={size} fallback={fallback} />
          </VideoWrapper>
        </Container>
      )}
    </ChatMessageVideo.Root>
  );
}

ChatMessageVideo.Root = styled.div``;

ChatMessageVideo.Fallback = styled(Shimmer)`
  border-radius: 12px;
`;
const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

const Container = styled(motion.div)<{ size: number }>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
`;

export default ChatMessageVideo;
